<div class="footer-sep">
  <div class="footer-sep-1"></div>
  <div class="footer-sep-2"></div>
  <div class="footer-sep-3"></div>
</div>
<div class="footer">
  <div class="wrapper">
    <div nz-row>
      <div nz-col nzSpan="24" [nzMd]="10" class="footer-logo">
        <img src="/assets/hill_light.svg" alt="Hill Labs">
      </div>
      <div nz-col nzSpan="24" [nzMd]="14">
        <div nz-row nzJustify="space-between">
          <div nz-col nzSpan="24" [nzMd]="8" class="footer-menu" *ngFor="let footerMenu of applicationConstants.footerMenus">
            <div class="footer-menu-header">{{footerMenu.name}}</div>
            <ul>
              <li *ngFor="let footerLink of footerMenu.links">
                <a *ngIf="footerLink.external" href="{{footerLink.url}}" target="_blank">{{footerLink.name}}</a>
                <a *ngIf="!footerLink.external && footerLink.fullDocumentNavigation" [href]="footerLink.url">{{footerLink.name}}</a>
                <a *ngIf="!footerLink.external && !footerLink.fullDocumentNavigation" [routerLink]="footerLink.url">{{footerLink.name}}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="footer2" nzAlign="center">
  <div class="wrapper" nzAlign="center">
    <div nz-row nzJustify="space-between" nzAlign="middle" class="footer2-socialmedia">
      <div nz-col>
        <span>{{applicationConstants.COPYRIGHT}}</span>
      </div>
      <div nz-col>
        <a href="{{applicationConstants.LINKEDIN}}" target="_blank" aria-hidden="true">
          <i nz-icon class="footer2-socialmedia-fudgesizing" nzType="icons/fontawesome/6.5.1/brands:linkedin-in"></i>
        </a>
        <a href="{{applicationConstants.FACEBOOK}}" target="_blank" aria-hidden="true">
          <i nz-icon nzType="icons/fontawesome/6.5.1/brands:facebook-f"></i>
        </a>
      </div>
    </div>
  </div>
</div>
